import * as colors from '../assets/js/colors'

export const ROTAS_CHECKLIST = {
  MENU: '/main/checklist-operacional/menu',
  CADASTRO: '/main/checklist-operacional/cadastro-checklist',
  ESTRUTURA: '/main/checklist-operacional/estrutura-checklist',
  PREENCHIMENTO: '/main/checklist-operacional/preenchimento-checklist',
  PREENCHER: '/main/checklist-operacional/preencher-checklist',
}

export const ResultadoResposta = {
  success: {
    label: 'Sucesso',
    color: colors.verde_success,
  },
  fail: {
    label: 'Falha',
    color: colors.vermelho,
  },
  neutral: {
    label: 'Neutro',
    color: colors.gray,
  },
}

export const PreenchimentoStatus = {
  Pendente: {
    label: 'Pendente',
    color: colors.laranja,
  },
  EmAndamento: {
    label: 'Em andamento',
    color: colors.azul,
  },
  Finalizado: {
    label: 'Finalizado',
    color: colors.verde_success,
  },
  Expirado: {
    label: 'Expirado',
    color: colors.vermelho,
  },
}

export function parsePreenchimentoStatus(status) {
  for (const key in PreenchimentoStatus) {
    const s = PreenchimentoStatus[key]
    if (s.label === status) return s
  }
  return { label: status || '', color: colors.gray }
}
